import API from '../api/api'
import {_exportDownloadLinkDecorator} from '../helper'

const SYNC_ARTICLES_PENDING = 'SYNC_ARTICLES_PENDING'
const SYNC_ARTICLES_PROGRESS = 'SYNC_ARTICLES_PROGRESS'
const SYNC_ARTICLES_RESPONSE = 'SYNC_ARTICLES_RESPONSE'
const SYNC_ARTICLE_PENDING = 'SYNC_ARTICLE_PENDING'
const SYNC_ARTICLE_RESPONSE = 'SYNC_ARTICLE_RESPONSE'
const SAVE_ARTICLES_PENDING = 'SAVE_ARTICLES_PENDING'
const SAVE_ARTICLES_PROGRESS = 'SAVE_AERTICLES_PROGRESS'
const SAVE_ARTICLES_RESPONSE = 'SAVE_ARTICLES_RESPONSE'
const SAVE_ARTICLES_ABORTED = 'SAVE_ARTICLES_ABORTED'
const SYNC_ARTICLE_METAFIELDS_PENDING = 'SYNC_ARTICLE_METAFIELDS_PENDING'
const SYNC_ARTICLE_METAFIELDS_PROGRESS = 'SYNC_ARTICLE_METAFIELDS_PROGRESS'
const SYNC_ARTICLE_METAFIELDS_RESPONSE = 'SYNC_ARTICLE_METAFIELDS_RESPONSE'
const SYNC_ARTICLE_METAFIELDS_ABORTED = 'SYNC_ARTICLE_METAFIELDS_ABORTED'
const CREATE_ARTICLE_CUSTOM_CONTENTS_PENDING = 'CREATE_ARTICLE_CUSTOM_CONTENTS_PENDING'
const CREATE_ARTICLE_CUSTOM_CONTENTS_PROGRESS = 'CREATE_ARTICLE_CUSTOM_CONTENTS_PROGRESS'
const CREATE_ARTICLE_CUSTOM_CONTENTS_RESPONSE = 'CREATE_ARTICLE_CUSTOM_CONTENTS_RESPONSE'
const DELETE_ARTICLE_CUSTOM_CONTENT_PENDING = 'DELETE_ARTICLE_CUSTOM_CONTENT_PENDING'
const DELETE_ARTICLE_CUSTOM_CONTENT_PROGRESS = 'DELETE_ARTICLE_CUSTOM_CONTENT_PROGRESS'
const DELETE_ARTICLE_CUSTOM_CONTENT_RESPONSE = 'DELETE_ARTICLE_CUSTOM_CONTENT_RESPONSE'
const EXPORT_ARTICLES_PENDING = 'EXPORT_ARTICLES_PENDING'
const EXPORT_ARTICLES_PROGRESS = 'EXPORT_ARTICLES_PROGRESS'
const EXPORT_ARTICLES_RESPONSE = 'EXPORT_ARTICLES_RESPONSE'
const IMPORT_ARTICLES_PENDING = 'IMPORT_ARTICLES_PENDING'
const IMPORT_ARTICLES_PROGRESS = 'IMPORT_ARTICLES_PROGRESS'
const IMPORT_ARTICLES_RESPONSE = 'IMPORT_ARTICLES_RESPONSE'
const RESET_ERRORS = 'RESET_ERRORS'
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS'

const initialState = {
  sync_articles_pending: true,
  sync_article_pending: false,
  sync_article_metafields_pending: false,
  create_article_custom_contents_pending: false,
  delete_article_custom_content_pending: false,
  save_articles_pending: false,
  export_articles_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  import_articles_pending: false,
  imported_entries: 0,
  progress: 0,
  error: false,
  articles: [],
}

function validateArticle(data, origin) {
  if (typeof data.general_errors !== 'undefined' && typeof data.general_errors.errors !== 'undefined') {
    data.general_errors.errors.forEach(item => {
      switch(item.object_key) {
        case 'handle' :
          //data.target.handle = origin.target.handle;
          break;
      }
    })
  }
  return data;
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case SYNC_ARTICLES_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_articles_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case SYNC_ARTICLES_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_ARTICLES_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          sync_articles_pending: false,
          error: false,
          articles: action.response.articles
        }
      } else {
        return {
          ...state,
          sync_articles_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case SYNC_ARTICLE_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_article_pending: true,
        error: false,
      }
    }
    case SYNC_ARTICLE_RESPONSE: {
      if(action.response.success === true) {
        let newArticles = state.articles.slice()
        let articleToUpdate = newArticles.find(x => x.id == action.response.article.id)
        
        articleToUpdate.synchronized = true;
        articleToUpdate.progress = action.response.article.progress

        articleToUpdate.source.title = action.response.article.source.title
        articleToUpdate.source.body_html = action.response.article.source.body_html
        articleToUpdate.source.handle = action.response.article.source.handle
        articleToUpdate.source.summary_html = action.response.article.source.summary_html
        articleToUpdate.source.page_title = action.response.article.source.page_title
        articleToUpdate.source.page_description = action.response.article.source.page_description
        articleToUpdate.source.image = action.response.article.source.image
        articleToUpdate.source.article_image = action.response.article.source.article_image
        
        articleToUpdate.target.title = action.response.article.target.title
        articleToUpdate.target.body_html = action.response.article.target.body_html
        articleToUpdate.target.handle = action.response.article.target.handle
        articleToUpdate.target.summary_html = action.response.article.target.summary_html
        articleToUpdate.target.page_title = action.response.article.target.page_title
        articleToUpdate.target.page_description = action.response.article.target.page_description
        articleToUpdate.target.image = action.response.article.target.image
        articleToUpdate.target.article_image = action.response.article.target.article_image

        articleToUpdate.custom_contents = action.response.article.custom_contents.slice()
        articleToUpdate.customSeo = action.response.article.custom_seo
        
        return {
          ...state,
          articles: newArticles,
          sync_article_pending: false
        }
      } else {
        return {
          ...state,
          sync_article_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1,
          },
        }
      }
    }

    case SAVE_ARTICLES_PENDING: {
      return {
        ...state,
        progress: 0,
        save_articles_pending: true,
        error: false,
      }
    }
    case SAVE_ARTICLES_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    // A save dropped because the merchant left the language never answers, and nothing refires
    // it the way a switch refires the sync - so the flag it set is cleared here. Not an error:
    // the merchant asked for the interruption.
    case SAVE_ARTICLES_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_articles_pending: false,
        error: false,
      }
    }
    case SAVE_ARTICLES_RESPONSE: {
      // The response echoes what was written for the language the save was issued for. The
      // abort races a response already on the wire, so it can still land after the merchant
      // selected another language - applying it then is what puts one language's text under another.
      if(action.stale === true) {
        return {
          ...state,
          save_articles_pending: false,
          error: false,
        }
      }

      let error = false;
      let newArticles = state.articles.slice();
      action.response.forEach((response, i) => {
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
          let newArticle = newArticles.find(x => x.id == action.items[i].id)
          newArticle.target = {...newArticle.target, ...action.items[i]}
        } else {
          let newArticle = newArticles.find(x => x.id == response.article.id)
          let article = validateArticle(response.article,newArticle)
          newArticle.progress = article.progress
          // commented out so source is not overwritten if backend returns insufficient data
          // newArticle.source = {...article.source}
          newArticle.target = {...article.target}
          newArticle.metafields = article.metafields.slice()
          newArticle.custom_contents = article.custom_contents.slice()
          newArticle.errors = article.general_errors.errors
        }
      })
      return {
        ...state,
        articles: newArticles,
        save_articles_pending: false,
        error: error
      }
    }

    case SYNC_ARTICLE_METAFIELDS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_article_metafields_pending: true,
        error: false,
      }
    }
    case SYNC_ARTICLE_METAFIELDS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_ARTICLE_METAFIELDS_ABORTED: {
      return {
        ...state,
        sync_article_metafields_pending: false,
        error: false,
      }
    }
    case SYNC_ARTICLE_METAFIELDS_RESPONSE: {
      // A row sync answers for the language it was issued in; landing after a switch it would
      // stamp that language's fields on the row now on screen and mark it as synced.
      if(action.stale === true) {
        return {
          ...state,
          sync_article_metafields_pending: false,
        }
      }
      if(action.response.success === true) {
        let newArticles = state.articles.slice()
        let articleToUpdate = newArticles.find(x => x.id == action.response.article_id)
        if(!articleToUpdate) {
          return { ...state, sync_article_metafields_pending: false }
        }
        
        articleToUpdate.metafields_synchronized = true;
        articleToUpdate.metafields = action.response.metafields.slice()

        return {
          ...state,
          sync_article_metafields_pending: false,
          articles: newArticles,
          error: false
        }
      } else {
        return {
          ...state,
          sync_article_metafields_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 2,
          },
        }
      }
    }
    case CREATE_ARTICLE_CUSTOM_CONTENTS_PENDING: {
      return {
        ...state,
        create_article_custom_contents_pending: true,
        error: false,
      }
    }
    case CREATE_ARTICLE_CUSTOM_CONTENTS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case CREATE_ARTICLE_CUSTOM_CONTENTS_RESPONSE: {
      let newArticles = state.articles.slice()
      let error = false;

      for(let i in action.response) {
        const response = action.response[i];
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
        } else {
          let articleToUpdate = newArticles.find(x => x.id == response.article_id)
          articleToUpdate.custom_contents.push({
            id: response.custom_content.id,
            source: {
              text: response.custom_content.source.text
            },
            target: {
              text: response.custom_content.target.text
            }
          });
        }
      }

      return {
        ...state,
        articles: newArticles,
        create_article_custom_contents_pending: false,
        error: error
      }
    }
    case DELETE_ARTICLE_CUSTOM_CONTENT_PENDING: {
      return {
        ...state,
        delete_article_custom_content_pending: true,
        error: false,
      }
    }
    case DELETE_ARTICLE_CUSTOM_CONTENT_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    case DELETE_ARTICLE_CUSTOM_CONTENT_RESPONSE: {
      let newArticles = state.articles.slice()
      let error = false;

      if(action.response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
      } else {
        let articleToUpdate = newArticles.find(x => x.id == action.response.article_id)
        articleToUpdate.custom_contents = articleToUpdate.custom_contents.filter(x => x.id != action.response.id)
      }

      return {
        ...state,
        articles: newArticles,
        delete_article_custom_content_pending: false,
        error: error
      }
    }
    case EXPORT_ARTICLES_PENDING: {
      return {
        ...state,
        progress: 0,
        export_articles_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case EXPORT_ARTICLES_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_ARTICLES_RESPONSE: {
      console.log(action.response)
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_articles_pending: false,
          export_po_download_url: _exportDownloadLinkDecorator(action.response.po_download_url, action.options),
          export_csv_download_url: _exportDownloadLinkDecorator(action.response.csv_download_url, action.options),
        }
      } else {
        return {
          ...state,
          progress: 100,
          export_pages_pending: false
        }
      }
    }
    case IMPORT_ARTICLES_PENDING: {
      return {
        ...state,
        progress: 0,
        import_articles_pending: true,
        import_cancelled: false,
        imported_entries: 0,
        error: false,
      }
    }
    case IMPORT_ARTICLES_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_ARTICLES_RESPONSE: {
      // the merchant cancelled after reviewing the file, nothing was imported
      if(action.response && action.response.cancelled === true) {
        return {
          ...state,
          progress: 0,
          import_articles_pending: false,
          import_cancelled: true
        }
      }
      let isOk = true;
      let importedEntries = 0;
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          importedEntries += response.imported_entries
        }
      })

      if(isOk == true) {
        return {
          ...state,
          progress: 100,
          import_articles_pending: false,
          imported_entries: importedEntries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_articles_pending: false,
          imported_entries: importedEntries,
          error: {
            message: action.response.filter(response => response.success !== true),
            action: action.action,
          }
        }
      }
    }
    case CLEAR_EXPORT_URLS: {
      return {
        ...state,
        progress: 0,
        export_articles_pending: false,
        export_csv_download_url: null,
        export_po_download_url: null,
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}
export const syncArticles = (language, sync_reset, callback, options = {}) => {
  return dispatch => {
    // A held sync is the bulk tool's own work: it runs and answers its callback,
    // but nothing of it reaches the store
    const mirror = (action) => {
      if(options.held !== true) {
        dispatch(action);
      }
    }
    mirror({
      type: SYNC_ARTICLES_PENDING
    })

    API.syncArticles(
      language,
      progress => {
        mirror({
          type: SYNC_ARTICLES_PROGRESS,
          progress: progress
        })
      },
      response => {
        // A dropped sync is not dispatched at all: the switch that dropped it has already
        // started the sync for the language now on screen, and that one owns the pending flag.
        if(response && response.aborted === true) {
          // The answer is dropped, but the callback still fires: callers use it to resolve a
          // promise, and one that never hears back leaves the ui waiting for good.
          if(callback) {
            callback(response);
          }
          return;
        }

        mirror({
          type: SYNC_ARTICLES_RESPONSE,
          response: response,
          action: () => syncArticles(language, sync_reset, callback)
        });
        if(callback) {
          callback(response);
        }
      },
      sync_reset,
      options
    )
  }
}

export const syncArticle = (articleId, languageId) => {  
  return dispatch => {
    dispatch({
      type: SYNC_ARTICLE_PENDING
    })

    API.syncArticle(
      articleId,
      languageId,
      response => {
        dispatch({
          type: SYNC_ARTICLE_RESPONSE,
          response: response,
          action: () => syncArticle(articleId, languageId)
        })
      }
    )
  }
}

export const saveArticles = (language, items, force = 0) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_ARTICLES_PENDING
    })

    API.saveArticles(
      language,
      items,
      force,
      progress => {
        dispatch({
          type: SAVE_ARTICLES_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_ARTICLES_ABORTED
          })
          return;
        }

        dispatch({
          type: SAVE_ARTICLES_RESPONSE,
          response: response,
          items: items,
          stale: getState().shop.shop.edit_language !== language,
          action: () => saveArticles(language, items, force)
        })
      })
  }
}

export const syncArticleMetafields = (article, language) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SYNC_ARTICLE_METAFIELDS_PENDING
    })

    API.syncArticleMetafields(
      article,
      language,
      progress => {
        dispatch({
          type: SYNC_ARTICLE_METAFIELDS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // Nothing refires a row sync after a switch, so the dropped one clears its own flag
        if(response && response.aborted === true) {
          dispatch({
            type: SYNC_ARTICLE_METAFIELDS_ABORTED
          })
          return;
        }

        dispatch({
          type: SYNC_ARTICLE_METAFIELDS_RESPONSE,
          response: response,
          stale: getState().shop.shop.edit_language !== language,
          action: () => syncArticleMetafields(article, language)
        }
      )
    })
  }
}

export const createArticleCustomContents = (article, language, items) => {  
  return dispatch => {
    dispatch({
      type: CREATE_ARTICLE_CUSTOM_CONTENTS_PENDING
    })

    API.createArticleCustomContents(
      article,
      language,
      items,
      progress => {
        dispatch({
          type: CREATE_ARTICLE_CUSTOM_CONTENTS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: CREATE_ARTICLE_CUSTOM_CONTENTS_RESPONSE,
          response: response,
          items: items,
          action: () => createArticleCustomContents(article, language, items)
        })
      })
  }
}

export const deleteArticleCustomContent = (article, ids) => {
  return dispatch => {
    dispatch({
      type: DELETE_ARTICLE_CUSTOM_CONTENT_PENDING
    })

    API.deleteArticleCustomContent(
      article,
      ids,
      progress => {
        dispatch({
          type: DELETE_ARTICLE_CUSTOM_CONTENT_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: DELETE_ARTICLE_CUSTOM_CONTENT_RESPONSE,
          response: response,
          action: () => deleteArticleCustomContent(article, ids)
        })
      })
  }
}

export const exportArticles = (language, options) => {
  return dispatch => {
    dispatch({
      type: EXPORT_ARTICLES_PENDING
    })

    API.exportArticles(
      language, 
      options,
      progress => {
        dispatch({
          type: EXPORT_ARTICLES_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_ARTICLES_RESPONSE,
          response: response,
          options: options,
          action: () => exportArticles(language, options)
        }
      )
    })
  }
}

export const importArticles = (file, fileType, language, options) => {
  return dispatch => {
    dispatch({
      type: IMPORT_ARTICLES_PENDING
    })

    API.importArticles(
      file,
      fileType,
      language, 
      options,
      progress => {
        dispatch({
          type: IMPORT_ARTICLES_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_ARTICLES_RESPONSE,
          response: response,
          action: () => importArticles(file, fileType, language, options)
        }
      )
    })
  }
}

export const clearExportUrls = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_EXPORT_URLS
    });
  }
}